export default {
    global: {
        close: 'Fechar',
        save: 'Salvar',
        continue : 'Continuar',
        confirmAndSend: 'Confirmar e enviar',
        mandatory_field: 'Este campo é obrigatório',
        checkbox_mandatory : 'Esta caixa de seleção é obrigatória',
        cancel: 'Cancelar',
        ok: 'Ok',
        yes: 'Sim',
        no: 'não',
        post_success: 'Dados bem enviados',
        code : 'CÓDIGO:'
    },
    menu: {
        main_menu: 'Menu principal',
        lmra: 'Abrir/Fechar LMRA',
        report_incident: 'Relatar um incidente',
        report_near_incident: 'Relatar um quase incidente',
        risk_analysis: 'Análise de risco',
        corona_analysis: 'Análise de Corona',
        scan_qr: "Digitalizar TAG/QR-CODE",
        process_issue: "Relatar problema no processo",
        checklist: "Ver lista de verificação",
        log_in: "Entrar",
        log_out: "Sair",
        emergency_numbers : "Números de emergência"
    },
    default_lrma: {
        what_label: 'Entendi o que fazer?',
        how_label: 'Eu sei como fazer isso?',
        risks_label: 'Reconheço os perigos e riscos?',
        control_label: 'Posso controlar isso?',
        default_pbm_label: 'Tenho o EPI correto?',
        default_pbm_question: 'Tenho o EPI correto?|1',
        lmra_job_state_positive: 'Ok, para iniciar o trabalho, revisaremos o LMRA quando ocorrerem alterações',
        lmra_job_state_negative: 'Ainda não estamos começando o trabalho.',
    },
    static_three_state_lmra: {
        getting_data_title: "A versão mais recente está sendo baixada.",
        could_not_load_newest_list_title: 'Atenção',
        could_not_load_newest_list: 'Algo deu errado ao obter a lista mais recente. Uma versão salva mais antiga da lista será exibida para que você possa continuar. Se o problema persistir, é melhor informar uma pessoa responsável.',
    },
    private_location: {
        title: 'Você está em um local privado?',
        body: 'Locais privados são locais fora dos locais relacionados ao trabalho.'
    },
    remarks: {
        remarksDialogTitle: 'Observações?',
        remarksDialogPlaceholder: 'Digite seus comentários aqui',
    },
    start_stop_screen: {
        start_work_btn: "comece a trabalhar",
        stop_work_btn: "parar de trabalhar",
    },
    work_report: {
        title: "Relatório de trabalho",
        placeholder: "Digite aqui seu relatório de trabalho",
        skip_work_report: "Pular",
        buildingListTitle : "Estamos construindo seu formulário de relatório de trabalho, isso não deve demorar muito.",
        criticalErrorTitle: 'Erro:',
        criticalErrorBody: 'Algo deu errado ao criar seu formulário de relatório de trabalho! Forneça ao seu gerente o código de erro abaixo:',
    },
    incident_report: {
        title: "Relatar incidente",
        placeholder: "O que aconteceu?",
    },
    oeps_report: {
        title: "Relatar quase incidente",
        placeholders: {
            machine: 'Qual máquina?',
            who: 'Quem estava envolvido?',
            what: 'O que aconteceu?',
            how: 'Como isso aconteceu / como isso aconteceu?',
            stop_card: 'Selecionar cartão de parada',
            location: 'Selecionar local',
            department: 'Selecionar departamento'
        },
        external_employee: 'É um funcionário externo',
        when_text_label: 'Quando isto aconteceu?',
        change_date_time_btn: 'Alterar data/hora'
    },
    risk_analysis: {
        title: {
            risk_default: "Análise de risco",
            risk_default_sub_title: '',
            corona: "Análise da coroa",
            corona_sub_title: 'Indique abaixo suas condições de trabalho e descubra como trabalhar com segurança.'
        },
        lists: {
            risk_default: {
                gravity: {
                    label: 'Gravidade',
                    gravity_01: 'leve, lesão sem absenteísmo',
                    gravity_02: 'importante, lesão e absenteísmo',
                    gravity_07: 'incapacidade grave e permanente/condições crónicas com incapacidade (parcial) para o trabalho',
                    gravity_15: 'muito grave, 1 morto (agudo a longo prazo)',
                    gravity_40: 'desastre, múltiplas mortes'
                },
                probability: {
                    label: 'Probabilidade',
                    probability_0_1: 'quase impossível de imaginar',
                    probability_0_2: 'praticamente impossível',
                    probability_0_5: 'imaginável, mas improvável',
                    probability_01: 'improvável, caso limítrofe',
                    probability_03: 'incomum, mas possível',
                    probability_06: 'bastante possível',
                    probability_10: 'esperado'
                },
                exposure: {
                    label: 'Exposição',
                    exposure_0_5: 'muito raro (1x por ano)',
                    exposure_01: 'raramente (anualmente)',
                    exposure_02: 'às vezes (mensalmente)',
                    exposure_03: 'ocasionalmente (semanalmente)',
                    exposure_06: 'regularmente (diariamente)',
                    exposure_10: 'constantemente',
                },
            },
            corona: {
                distance: {
                    label: 'Distância esperada entre mim e outras pessoas:',
                    distance_01: 'D > 8 m',
                    distance_02: '6 m < D < 8 m',
                    distance_07: '2 m < D < 6 m',
                    distance_15: '1,5 m < D < 2 m',
                    distance_40: '1 m < D < 1,5 m',
                    distance_100: 'D < 1 m'
                },
                probability: {
                    label: 'Percebo que outros ...',
                    probability_0_1: 'use máscara FFP2 + óculos + roupas de proteção',
                    probability_0_2: 'use máscara FFP2 + óculos',
                    probability_0_5: 'use máscara ou protetor facial',
                    probability_01: 'respeite definitivamente as Diretrizes Corona',
                    probability_03: 'talvez respeite as Diretrizes Corona',
                    probability_06: 'violar algumas diretrizes Corona',
                    probability_10: 'Violação de múltiplas diretrizes Corona'
                },
                exposure: {
                    label: 'Chance de contato mais próximo do que o esperado:',
                    exposure_0_5: 'Muito improvável',
                    exposure_01: 'Quando várias coisas dão errado',
                    exposure_02: 'Incomum, se certas coisas derem errado',
                    exposure_03: 'Possivelmente, as chances não são tão grandes',
                    exposure_06: 'Bem possível, chance razoável',
                    exposure_10: 'Esperável, quase certamente',
                },
            },
        },
        results: {
            risk_default: {
                kinneyCode1: 'nenhum',
                kinneyCode2: 'atenção necessária',
                kinneyCode3: 'medidas necessárias podem ser planejadas',
                kinneyCode4: 'melhoria imediata',
                kinneyCode5: 'pare de funcionar'
            },
            corona: {
                kinneyCode1: 'Risco aceitável: Não são necessárias medidas de proteção adicionais',
                kinneyCode2: 'Possível risco: precisa de atenção',
                kinneyCode3: 'Risco grave: tome medidas de proteção',
                kinneyCode4: 'Alto risco: tome medidas de proteção aumentadas',
                kinneyCode5: 'Risco muito alto: tente ajustar a atividade, se impossível, tome medidas de proteção máximas'
            },
        },
        supportive_texts: {
            risk_default: {
                supportiveText1: '',
                supportiveText2: '',
                supportiveText3: '',
                supportiveText4: '',
                supportiveText5: ''
            },
            corona: {
                supportiveText1: 'Conheço e respeito as Diretrizes Corona que se aplicam ao meu ambiente de trabalho.',
                supportiveText2: 'Conheço e respeito as diretrizes Corona aplicáveis. Peço expressamente às pessoas do meu ambiente de trabalho que também cumpram as diretrizes do Corona. Não são necessárias outras medidas de proteção adicionais.',
                supportiveText3: 'Fui ou desinfetei as mãos no início e no final da atividade. Uso um protetor facial ou uma máscara bucal adequada em combinação com óculos (de segurança). As pessoas no meu ambiente de trabalho também devem usar pelo menos uma proteção facial ou máscara nasal (de preferência junto com óculos de segurança). Sei utilizar corretamente esses equipamentos de proteção coletiva e aplicá-los na prática. Conheço e respeito as Diretrizes Corona aplicáveis e peço expressamente às pessoas no meu ambiente de trabalho que também cumpram as Diretrizes Corona.',
                supportiveText4: 'Desinfetei as mãos no início e no final da atividade e após qualquer toque inseguro. Eu uso uma máscara protetora bucal (de preferência uma máscara de proteção respiratória FFP2) em combinação com um protetor facial ou óculos de proteção. Sei usar esses equipamentos de proteção individual (EPI) corretamente e aplicá-los na prática. Conheço as diretrizes da Corona que se aplicam ao ambiente de trabalho e, claro, continuo a respeitar essas diretrizes da Corona. Peço às pessoas no meu ambiente de trabalho que também tomem as medidas de segurança necessárias e observem as diretrizes do Corona.',
                supportiveText5: 'Primeiro considero se a atividade pode ser realizada de outra forma, sem contato direto com outras pessoas. Caso isso não seja possível, tomarei todas as medidas de segurança possíveis. Estive ou desinfetei as mãos no início e no final da atividade. Eu uso luvas de proteção. Uso máscara de proteção respiratória (pelo menos FFP2) em combinação com protetor facial ou óculos de proteção e roupas de proteção. Sei usar corretamente esses equipamentos de proteção individual (EPI) e aplicá-los na prática. Conheço as diretrizes corona que se aplicam ao ambiente de trabalho e, claro, continuo a respeitar essas diretrizes Corona. Peço às pessoas em meu ambiente de trabalho que também tomem as medidas de segurança necessárias e observem cuidadosamente as diretrizes Corona.'
            }
        },
        leave_warning: {
            risk_default: {
                title: 'Atenção',
                body: 'Você está prestes a fechar esta janela sem enviar o relatório de análise de risco atual. Tem certeza de que deseja sair da página?'
            },
            corona: {
                title: 'Atenção',
                body: 'Você está prestes a fechar esta janela sem enviar o relatório de análise Corona atual. Tem certeza de que deseja sair da página?'
            }
        },
        report_title: 'Relatório de análise',
        placeholder_report: 'Descreva/esclareça a situação'
    },
    process_issue: {
        title: "Relatar um problema de processo",
        placeholders: {
            issue_type_select: 'Selecione o tipo de problema',
            failure_detail: 'Selecione detalhes do problema',
            who: 'Quem estava envolvido?',
            description: 'Descreva o problema',
            cnf: 'CNF?',
            comment: 'Observações/comentários adicionais',
            other: 'Outro'
        }
    },
    checklist: {
        getting_data_title: "A lista de verificação mais recente é coletada."
    },
    data_transfer: {
        post_busy: 'Aguarde, os dados estão sendo enviados.',
        post_success: 'Dados enviados bem.'
    },
    gdpr_disclaimer: {
        title: 'Proposta do RGPD:',
        body: 'Enviando um item da aplicação lmra-first os seguintes itens serão armazenados no banco de dados: localização atual (GPS - coordenadas (após confirmação)) e a hora exata (e somente naquele horário). Nenhum desses itens será vendido a outras partes ou organizações. Os dados armazenados serão utilizados apenas na ordem do projeto e nas condições de trabalho relacionadas.',
        accept_btn: 'Aceito',
        decline_btn: 'Sair do aplicativo'
    },
    data_notice: {
        button_text: 'O que acontece com essas informações?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings: {
        alert_cn_pid_nf_title: 'Opa, parece que você esqueceu algo:',
        alert_cn_pid_nf_body: 'Nome do cliente e/ou ID do projeto não preenchido, verifique os valores',
        client_select_placeholder: 'Selecione um cliente',
        project_select_placeholder: 'Selecione um projeto',
        client_not_in_list_label : 'Cliente não na lista',
        project_not_in_list_label : 'Projeto não na lista',
        client_name: 'Nome do cliente',
        project_id: 'ID do projeto',
        project_distance: 'Distância do Projeto',
        project_shift: 'Mudança do projeto',
        user_initials: 'Suas iniciais',
        project_tag_code_label: 'Código TAG do projeto',
        warning: {
            intro: 'Agora você está usando entrada manual para',
            reason_server: 'porque os dados do servidor não puderam ser carregados!',
            reason_client_not_listed: 'porque o cliente não estava na lista atual!',
            reason_project_not_listed: 'porque o projeto não estava na lista atual!',
            dbl_check: 'Verifique todos os seus valores antes de salvar!',
            admin_msg: 'Se esta mensagem continuar aparecendo entre em contato com seu administrador e relate isso!'
        },
        input_errors: {
            no_client_selected: 'Por favor selecione um cliente',
            no_project_selected: 'Por favor, selecione um projeto',
        },
        loading_cap: 'Carregando dados do servidor',
        custom_shifts_labels: {
            open_field : 'Campo aberto'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Erro de verificação",
                body : "Formato de dados QR inválido detectado"
            },
            error_popup_notice_manual_mode : {
                title : "Algo correu mal",
                body : "Algo correu mal ao carregar os dados do RRQRCode, mudando para o modo manual"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Carregando stream da câmera...',
            default_error_button_test: 'Sair'
        },
        overlay_view: {
            title : 'Verificar TAG - Código',
            info_manual : 'Está com problemas para digitalizar? Usar entrada manual',
            manual_btn : 'Habilitar entrada manual.',
            errors : {
                invalid_tag_title: 'TAG-CODE inválido',
                invalid_tag_body : 'O código que você digitalizou não é um TAG-CODE válido, digitalize um TAG-CODE válido ou mude para entrada manual.',
                error_btn_txt: 'Ativar entrada manual'
            }
        }
    },
    errors: {
        checklistNotLoaded: 'Algo deu errado ao obter a lista, tente novamente mais tarde.',
        EmergencyNumbersOverviewNotLoaded: 'Algo deu errado ao obter a lista, tente novamente mais tarde.',
        missing_critical_resource_title: 'Erro ao carregar dados:',
        missing_critical_resource: 'Um recurso está faltando no aplicativo. Informe o código abaixo ao administrador.',
        app_corrupt: 'Parece que a configuração do aplicativo está corrompida. Entre em contato com seu administrador.',
        data_save_failed: 'Não foi possível enviar os dados, tente novamente mais tarde...',
        camera: {
            NotAllowedError: 'ERRO: Você deve conceder permissão para acesso à câmera',
            NotFoundError: 'ERRO: Nenhuma câmera neste dispositivo',
            NotSupportedError: 'ERRO: contexto seguro necessário (HTTPS, localhost)',
            NotReadableError: 'ERRO: A câmera já está sendo usada?',
            OverconstrainedError: 'ERRO: As câmeras instaladas não são adequadas',
            StreamApiNotSupportedError: 'ERRO: Stream API não é compatível com este navegador',
        },
        no_internet: 'Oooops... você está offline, verifique sua conexão com a internet!',
        input_validation: {
            char_limit: 'É permitido um máximo de %n caracteres'
        },
        auth0 :{
            unverified_email : {
                error: 'Erro: O endereço de e-mail não foi verificado! Verifique seus e-mails!',
                info : 'Para obter acesso a este aplicativo <b>você precisa verificar seu endereço de e-mail</b>.<br/><br/>Você <b>receberá um e-mail</b> em breve <b>de |SENDER| </b><br/><br/><i>Para verificar seu endereço de e-mail. Siga as instruções no e-mail</i>'
            }
        }
    },
    noDataText: "Dados não disponíveis...",
    defaultDynamicQuestion: '{"dynamic_questions":[{"id":null,"question":"Tenho o EPI correto?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'E-mail',
        passwordLabel : 'Senha',
        rememberMeLabel : "Lembre de mim",
        logInBtn: "Entrar",
        logOutBtn: "Sair",
        verifyMFABtn : "Verificar",
        errorPopupTitle : "Erro",
        confirmIdentify : "Ainda você?",
        errors :{
            required : "Obrigatório",
            invalidEmail : "E-mail inválido",
            unknownError : "Ocorreu um erro desconhecido"
        },
        registerNewAccountBtn : "Criar uma nova conta.",
        forgotPassword : "Esqueceu sua senha"
    },
    lmraComponent : {
        loadingProjectData : 'Preparando seu formulário LMRA, aguarde',
        startWorkQrDialog:{
            title: "Selecione o método de início:",
            body : "Se tiver o código QR Risk-reflex presente, seleccione o código QR, caso contrário, utilize o método de introdução manual",
            positive_btn : "código QR",
            negative_btn : "Método manual"
        },
        errors : {
            unknownError : "Ocorreu um erro desconhecido",
            noListDataFound: "Erro: NENHUM DADO DA LISTA ENCONTRADO!! VOLTE PARA O LMRA PADRÃO",
            noDefaultListFound: 'Nenhuma lista padrão disponível! Usando LMRA PADRÃO!',
        }
    },
    customLmraLists : {
        buildingListTitle : "Construindo seu formulário LMRA, isso não deve demorar muito.",
        criticalErrorTitle: 'Erro:',
        criticalErrorBody: 'Algo deu errado ao construir seu formulário LMRA! Agora carregaremos o LMRA padrão! forneça ao seu gerente o código de erro abaixo: ',
    },
    workSessions :{
        global : {
          expiredLabel : "Expirado"
        },
        resumeSessionDialog : {
            titleActiveSession : "Sessão ativa encontrada",
            titleActiveSessionExpired : "(Expirado) Sessão ativa encontrada",
        },
        workSessionServiceNaDialog :{
            title : 'SERVIÇO DE SESSÃO DE TRABALHO INDISPONÍVEL',
            body : 'Desculpe, não conseguimos determinar se você tem uma sessão aberta<br/><br/>' +
                '<b>Módulo LMRA está bloqueado: você não pode iniciar ou fechar uma sessão. </b><br/> No entanto, você ainda pode enviar relatórios de incidentes (fora da sessão)<br/>' +
                'Você receberá uma notificação quando o serviço de sessão estiver disponível<br/><br/>' +
                'se este erro persistir, avise seu administrador..'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Desculpe: <b>O Módulo LMRA está atualmente bloqueado: você não pode iniciar ou fechar uma sessão. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : 'A resposta do servidor não contém dados da sessão',
                    could_not_save_session : 'Não foi possível salvar os dados da sessão localmente...',
                    invalid_session_data : 'Dados da sessão inválidos, os dados podem estar corrompidos'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Ocorreu um erro desconhecido",
            notFound : "Nenhum código de grupo encontrado."
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Número de emergência padrão",
        getting_data_title: "Obtendo os números mais recentes"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Lista de verificação ativa",
                other_checklists : "Outras listas de verificação"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Visualizando:"
            },
            warning_message : "Você está visualizando uma lista de verificação que não é a lista ativa atual. Para visualizar a lista ativa, use a guia \"Lista de verificação ativa\" na parte superior"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "A versão está atualizada",
            version_minor_update : "Versão mais recente disponível (pode não estar disponível para o seu locatário)",
            update_required : "Aviso! Este aplicativo está desatualizado, ele deve ser atualizado automaticamente. Se esta mensagem persistir, entre em contato com o administrador."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Tipo de código QR errado",
                    body : "Este tipo de código QR não é suportado aqui"
                },
                wrong_tenant : {
                    title : "Inquilino Errado",
                    body : "Este código QR não pode ser utilizado pela sua empresa"
                },
                invalid_qr_code : {
                    title : "Código QR inválido",
                    body : "Este não é um código QR válido do Risk Reflex e não pode ser utilizado"
                },
                invalid_qr_data : {
                    title : "Dados de código QR inválidos",
                    body : "Este código QR não pode ser traduzido, o código QR pode estar corrompido"
                }
            },
            title : "Verificar o código QR do Risk-Reflex",
            info_manual : 'Está com problemas para digitalizar? Usar entrada manual',
            manual_btn: "Mudar para modo manual"
        }
    }
}